let view = null;

export default {
	namespace: 'template-about',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: AboutView } = await import(/* webpackChunkName: "about-view" */ '../../templates/AboutView');
		view = new AboutView(next.container);
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
